import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import loader, { PageResourceStatus } from "./loader";
import shallowCompare from "shallow-compare";
let EnsureResources = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(EnsureResources, _React$Component);
  function EnsureResources(props) {
    var _this;
    _this = _React$Component.call(this) || this;
    const {
      location,
      pageResources
    } = props;
    _this.state = {
      location: {
        ...location
      },
      pageResources: pageResources || loader.loadPageSync(location.pathname)
    };
    return _this;
  }
  EnsureResources.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    let {
      location
    } = _ref;
    if (prevState.location.href !== location.href) {
      const pageResources = loader.loadPageSync(location.pathname);
      return {
        pageResources,
        location: {
          ...location
        }
      };
    }
    return {
      location: {
        ...location
      }
    };
  };
  var _proto = EnsureResources.prototype;
  _proto.loadResources = function loadResources(rawPath) {
    loader.loadPage(rawPath).then(pageResources => {
      if (pageResources && pageResources.status !== PageResourceStatus.Error) {
        this.setState({
          location: {
            ...window.location
          },
          pageResources
        });
      } else {
        window.history.replaceState({}, ``, location.href);
        window.location = rawPath;
      }
    });
  };
  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    // Always return false if we're missing resources.
    if (!nextState.pageResources) {
      this.loadResources(nextProps.location.pathname);
      return false;
    }
    if (process.env.BUILD_STAGE === `develop` && nextState.pageResources.stale) {
      this.loadResources(nextProps.location.pathname);
      return false;
    }

    // Check if the component or json have changed.
    if (this.state.pageResources !== nextState.pageResources) {
      return true;
    }
    if (this.state.pageResources.component !== nextState.pageResources.component) {
      return true;
    }
    if (this.state.pageResources.json !== nextState.pageResources.json) {
      return true;
    }
    // Check if location has changed on a page using internal routing
    // via matchPath configuration.
    if (this.state.location.key !== nextState.location.key && nextState.pageResources.page && (nextState.pageResources.page.matchPath || nextState.pageResources.page.path)) {
      return true;
    }
    return shallowCompare(this, nextProps, nextState);
  };
  _proto.render = function render() {
    if (process.env.NODE_ENV !== `production` && !this.state.pageResources) {
      throw new Error(`EnsureResources was not able to find resources for path: "${this.props.location.pathname}"
This typically means that an issue occurred building components for that path.
Run \`gatsby clean\` to remove any cached elements.`);
    }
    return this.props.children(this.state);
  };
  return EnsureResources;
}(React.Component);
export default EnsureResources;